module.exports = __webpack_public_path__ + "static/media/ticket-alt.9d23ade8.svg";